
import AuthenticationStore from './AuthenticationStore';

export { default } from './AuthenticationStore';
export const authenticationStore = new AuthenticationStore();
